var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ImportConfig_1;
import { ConnectionType } from '@symon-ai/wisepipe-common-connection';
import { JSON, JsonConverter, JsonDiscriminatorProperty, JsonSchemaV2, MapConverter, OnDeserialized } from '@symon-ai/wisepipe-serialize';
import { DataCategory } from '../importTask';
import './columnUpdate'; // force import JSON schema
import { ColumnUpdate, ColumnUpdateType } from './columnUpdate';
import '../importFilter'; // force import JSON schema
import { ImportFilter } from '../importFilter';
import { importConfigSchemaValidation } from '../../validations.generated';
export const COLUMN_LIMIT = 500;
export var ImportConfigType;
(function (ImportConfigType) {
    ImportConfigType["S3Csv"] = "s3csv";
    ImportConfigType["GSheets"] = "gsheets";
    ImportConfigType["GoogleAdWords"] = "adwords";
    ImportConfigType["GoogleAnalytics"] = "googleAnalytics";
    ImportConfigType["Shopify"] = "shopify";
    ImportConfigType["MySql"] = "mySql";
    ImportConfigType["Oracle"] = "oracle";
    ImportConfigType["PostgreSql"] = "postgreSql";
    ImportConfigType["AmazonAurora"] = "amazonAurora";
    ImportConfigType["AmazonRedshift"] = "amazonRedshift";
    ImportConfigType["AmazonS3"] = "amazonS3";
    ImportConfigType["Icm"] = "icm";
    ImportConfigType["SalesForce"] = "salesForce";
    ImportConfigType["Parquet"] = "parquet";
    ImportConfigType["Excel"] = "excel";
    ImportConfigType["Global"] = "global";
    ImportConfigType["Hubspot"] = "hubspot";
    ImportConfigType["Symon"] = "symon";
    ImportConfigType["Dynamics"] = "dynamics";
    ImportConfigType["S3Parquet"] = "s3parquet";
    ImportConfigType["Snowflake"] = "snowflake";
    ImportConfigType["MsSql"] = "msSql";
    ImportConfigType["AgentSync"] = "agentSync";
    ImportConfigType["Workday"] = "workday";
    ImportConfigType["WorkdayRaaS"] = "workdayRaaS";
    ImportConfigType["Tqp"] = "tqp";
    ImportConfigType["Tableau"] = "tableau";
    ImportConfigType["Sftp"] = "sftp";
    ImportConfigType["PowerBI"] = "powerbi";
    ImportConfigType["Rest"] = "rest";
    ImportConfigType["Gong"] = "gong";
    ImportConfigType["Fwf"] = "fwf";
    ImportConfigType["NetSuite"] = "netSuite";
    ImportConfigType["OneDrive"] = "oneDrive";
    ImportConfigType["EltApi"] = "eltApi";
    // up next
    ImportConfigType["MicrosoftSqlServer"] = "microsoftSqlServer";
    ImportConfigType["Stripe"] = "stripe";
    // not implemented
    ImportConfigType["MicrosoftDynamics365"] = "microsoftDynamics365";
    ImportConfigType["Github"] = "github";
    ImportConfigType["FacebookAds"] = "facebookAds";
    ImportConfigType["Amplitude"] = "amplitude";
    ImportConfigType["AppsFlyer"] = "appsFlyer";
    ImportConfigType["CustomerIo"] = "customerIo";
    ImportConfigType["FreshDesk"] = "freshDesk";
    ImportConfigType["Fullstory"] = "fullstory";
    ImportConfigType["GoogleCloud"] = "googleCloud";
    ImportConfigType["GoogleEcommerce"] = "googleEcommerce";
    ImportConfigType["Listrak"] = "listrak";
    ImportConfigType["LivePerson"] = "livePerson";
    ImportConfigType["OnFleet"] = "onFleet";
    ImportConfigType["Saasquatch"] = "saasquatch";
    ImportConfigType["Selligent"] = "selligent";
    ImportConfigType["UserVoice"] = "userVoice";
    ImportConfigType["Vero"] = "vero";
    ImportConfigType["AdRoll"] = "adRoll";
    ImportConfigType["AfterShip"] = "afterShip";
    ImportConfigType["Asana"] = "asana";
    ImportConfigType["Autopilot"] = "autopilot";
    ImportConfigType["Azure"] = "azure";
    ImportConfigType["BigCommerce"] = "bigCommerce";
    ImportConfigType["BingAds"] = "bingAds";
    ImportConfigType["BrainTree"] = "brainTree";
    ImportConfigType["Bronto"] = "bronto";
    ImportConfigType["CampaignManager"] = "campaignManager";
    ImportConfigType["CampaignMonitor"] = "campaignMonitor";
    ImportConfigType["ChargeBee"] = "chargeBee";
    ImportConfigType["CloseIo"] = "closeIo";
    ImportConfigType["Clubspeed"] = "clubspeed";
    ImportConfigType["Codat"] = "codat";
    ImportConfigType["Contentful"] = "contentful";
    ImportConfigType["Delighted"] = "delighted";
    ImportConfigType["Drip"] = "drip";
    ImportConfigType["Eloqua"] = "eloqua";
    ImportConfigType["Formkeep"] = "formkeep";
    ImportConfigType["Front"] = "front";
    ImportConfigType["Ftp"] = "ftp";
    ImportConfigType["Gitlab"] = "gitlab";
    ImportConfigType["Harvest"] = "harvest";
    ImportConfigType["Heap"] = "heap";
    ImportConfigType["HelpScout"] = "helpScout";
    ImportConfigType["Heroku"] = "heroku";
    ImportConfigType["IbmDb2"] = "ibmDb2";
    ImportConfigType["Invoiced"] = "invoiced";
    ImportConfigType["Iterable"] = "iterable";
    ImportConfigType["Klaviyo"] = "klaviyo";
    ImportConfigType["Magento"] = "magento";
    ImportConfigType["Mailjet"] = "mailjet";
    ImportConfigType["MariaDb"] = "mariaDb";
    ImportConfigType["Mixpanel"] = "mixpanel";
    ImportConfigType["MongoDb"] = "mongoDb";
    ImportConfigType["Outbrain"] = "outbrain";
    ImportConfigType["Particle"] = "particle";
    ImportConfigType["Purple"] = "purple";
    ImportConfigType["QuickBase"] = "quickBase";
    ImportConfigType["Recurly"] = "recurly";
    ImportConfigType["Responsys"] = "responsys";
    ImportConfigType["Revinate"] = "revinate";
    ImportConfigType["SalesforceDesk"] = "salesforceDesk";
    ImportConfigType["SalesforecePardot"] = "salesforcePardot";
    ImportConfigType["Segment"] = "segment";
    ImportConfigType["SendGrid"] = "sendGrid";
    ImportConfigType["SendWithUs"] = "sendWithUs";
    ImportConfigType["ShipHero"] = "shipHero";
    ImportConfigType["Shippo"] = "shippo";
    ImportConfigType["SparkPost"] = "sparkPost";
    ImportConfigType["Square"] = "square";
    ImportConfigType["Taboola"] = "taboola";
    ImportConfigType["Toggl"] = "toggl";
    ImportConfigType["Trello"] = "trello";
    ImportConfigType["Typeform"] = "typeform";
    ImportConfigType["UrbanAirship"] = "urbanAirship";
    ImportConfigType["WebHooks"] = "webhooks";
    ImportConfigType["Yotpo"] = "yotpo";
    ImportConfigType["Zapier"] = "zapier";
    ImportConfigType["ZendeskChat"] = "zendeskChat";
    ImportConfigType["ZendeskSupport"] = "zendeskSupport";
    ImportConfigType["GoogleBigQuery"] = "googleBigQuery";
    ImportConfigType["Intercom"] = "intercom";
    // REST based
    ImportConfigType["SapSuccessFactors"] = "sapSuccessFactors";
    ImportConfigType["SapCrm"] = "sapCrm";
    ImportConfigType["Ukg"] = "ukg";
    ImportConfigType["OracleHcm"] = "oracleHcm";
    ImportConfigType["Adp"] = "Adp";
    ImportConfigType["Dynamics365Sales"] = "dynamics365Sales";
    ImportConfigType["CeridianDayforce"] = "ceridianDayforce";
    ImportConfigType["OracleCrm"] = "oracleCrm";
    ImportConfigType["OracleErpCloud"] = "oracleErpCloud";
    ImportConfigType["SageIntacct"] = "sageIntacct";
    ImportConfigType["BambooHr"] = "bambooHr";
    ImportConfigType["SapErp"] = "sapErp";
    ImportConfigType["GoogleCloudPlatformCloudStorage"] = "googleCloudPlatformCloudStorage";
    ImportConfigType["Sas"] = "sas";
    ImportConfigType["Dropbox"] = "dropbox";
    ImportConfigType["GoogleDrive"] = "googleDrive";
    ImportConfigType["Jira"] = "jira";
    ImportConfigType["Monday"] = "monday";
    ImportConfigType["Zuora"] = "zuora";
    ImportConfigType["AdobeAnalytics"] = "adobeAnalytics";
    ImportConfigType["ZoomInfo"] = "zoomInfo";
    ImportConfigType["Marketo"] = "marketo";
    ImportConfigType["ActiveCampaign"] = "activeCampaign";
    ImportConfigType["Mailchimp"] = "mailchimp";
    ImportConfigType["Infor"] = "infor";
    ImportConfigType["CornerstoneOnDemand"] = "cornerstoneOnDemand";
    ImportConfigType["Gusto"] = "gusto";
    ImportConfigType["PaychexFlex"] = "paychexFlex";
    ImportConfigType["Zendesk"] = "zendesk";
    ImportConfigType["ServiceNow"] = "serviceNow";
    ImportConfigType["ZohoCrm"] = "zohoCrm";
    ImportConfigType["Pipedrive"] = "pipedrive";
    ImportConfigType["QuickBooks"] = "quickBooks";
    ImportConfigType["Xero"] = "xero";
    ImportConfigType["Freshbooks"] = "freshbooks";
    ImportConfigType["ZohoBooks"] = "zohoBooks";
    ImportConfigType["WaveFinancial"] = "waveFinancial";
})(ImportConfigType || (ImportConfigType = {}));
export const importConfigSchema = {
    $id: 'urn:wisepipe-common-data:ImportConfig',
    type: 'object',
    properties: {
        importConfigType: {
            type: 'string',
            enum: Object.values(ImportConfigType)
        },
        columnsToUpdate: {
            type: 'object',
            additionalProperties: {
                type: 'array',
                items: { $ref: 'urn:wisepipe-common-data:ColumnUpdate' },
                uniqueItems: true
            }
        },
        columnsToDrop: {
            type: 'object',
            additionalProperties: { type: 'array', items: { type: 'string' }, uniqueItems: true }
        },
        columnsToMask: {
            type: 'object',
            additionalProperties: { type: 'array', items: { type: 'string' }, uniqueItems: true }
        },
        filters: {
            type: 'object',
            additionalProperties: { $ref: 'urn:wisepipe-common-data:ImportFilter' }
        },
        dataCategory: { type: 'string', enum: Object.values(DataCategory) }
    },
    required: ['importConfigType']
};
let ImportConfig = ImportConfig_1 = class ImportConfig {
    ToColumnsUpdate() {
        if (this.columnsToDrop === undefined && this.columnsToMask === undefined) {
            return;
        }
        const columnsToUpdate = new Map();
        if (this.columnsToDrop) {
            for (const [stream, dropColumns] of this.columnsToDrop) {
                const updates = [];
                for (const column of dropColumns) {
                    updates.push(new ColumnUpdate(column, ColumnUpdateType.DROP));
                }
                columnsToUpdate.set(stream, updates);
            }
        }
        if (this.columnsToMask) {
            for (const [stream, maskColumns] of this.columnsToMask) {
                const updates = [];
                for (const column of maskColumns) {
                    updates.push(new ColumnUpdate(column, ColumnUpdateType.MASK));
                }
                let currentUpdates = [];
                if (columnsToUpdate.has(stream)) {
                    currentUpdates = columnsToUpdate.get(stream);
                }
                currentUpdates.push(...updates);
                columnsToUpdate.set(stream, currentUpdates);
            }
        }
        this.columnsToUpdate = columnsToUpdate;
        this.columnsToDrop = undefined;
        this.columnsToMask = undefined;
    }
    constructor(importConfigType, columnsToUpdate, filters, dataCategory) {
        this.importConfigType = importConfigType;
        if (columnsToUpdate !== undefined)
            this.columnsToUpdate = columnsToUpdate;
        if (filters !== undefined)
            this.filters = filters;
        if (dataCategory !== undefined)
            this.dataCategory = dataCategory;
        JSON.validate(this, ImportConfig_1);
    }
    static getConnectionType(importConfigType, connectionVersion) {
        // For import sources that don't require a connection (CSV, SQL, PARQUET), return undefined
        switch (importConfigType) {
            case ImportConfigType.GoogleAdWords:
            case ImportConfigType.GoogleAnalytics:
                return ConnectionType.Google;
            case ImportConfigType.GSheets: {
                if (connectionVersion === 2)
                    return ConnectionType.GSheetsImport;
                return ConnectionType.Google;
            }
            case ImportConfigType.Shopify:
                return ConnectionType.Shopify;
            case ImportConfigType.SalesForce:
                return ConnectionType.SalesForce;
            case ImportConfigType.PostgreSql:
                return ConnectionType.PostgreSql;
            case ImportConfigType.Icm:
                return ConnectionType.Icm;
            case ImportConfigType.MySql:
                return ConnectionType.MySql;
            case ImportConfigType.MsSql:
                return ConnectionType.MsSql;
            case ImportConfigType.Oracle:
                return ConnectionType.Oracle;
            case ImportConfigType.AmazonRedshift:
                return ConnectionType.AmazonRedshift;
            case ImportConfigType.AmazonAurora:
                return ConnectionType.AmazonAurora;
            case ImportConfigType.Hubspot:
                return ConnectionType.Hubspot;
            case ImportConfigType.Snowflake:
                return ConnectionType.Snowflake;
            case ImportConfigType.Dynamics:
                return ConnectionType.Dynamics;
            case ImportConfigType.AmazonS3:
                return ConnectionType.AmazonS3;
            case ImportConfigType.AgentSync:
                return ConnectionType.AgentSync;
            case ImportConfigType.Workday:
                return ConnectionType.Workday;
            case ImportConfigType.WorkdayRaaS:
                return ConnectionType.WorkdayRaaS;
            case ImportConfigType.Tqp:
                return ConnectionType.Tqp;
            case ImportConfigType.Tableau:
                return ConnectionType.Tableau;
            case ImportConfigType.Sftp:
                return ConnectionType.Sftp;
            case ImportConfigType.PowerBI:
                return ConnectionType.PowerBI;
            case ImportConfigType.Rest:
                return ConnectionType.Rest;
            case ImportConfigType.Gong:
                return ConnectionType.Gong;
            case ImportConfigType.NetSuite:
                return ConnectionType.NetSuite;
            case ImportConfigType.OneDrive:
                return ConnectionType.OneDrive;
            // REST based placeholder import types use RestImportConfig, so their connections in the backend use RestConnection.
            // Added for use in UI to retrieve connectionType from importConfigType
            case ImportConfigType.SapSuccessFactors:
                return ConnectionType.SapSuccessFactors;
            case ImportConfigType.SapCrm:
                return ConnectionType.SapCrm;
            case ImportConfigType.Ukg:
                return ConnectionType.Ukg;
            case ImportConfigType.OracleHcm:
                return ConnectionType.OracleHcm;
            case ImportConfigType.Adp:
                return ConnectionType.Adp;
            case ImportConfigType.Dynamics365Sales:
                return ConnectionType.Dynamics365Sales;
            case ImportConfigType.CeridianDayforce:
                return ConnectionType.CeridianDayforce;
            case ImportConfigType.OracleCrm:
                return ConnectionType.OracleCrm;
            case ImportConfigType.OracleErpCloud:
                return ConnectionType.OracleErpCloud;
            case ImportConfigType.SageIntacct:
                return ConnectionType.SageIntacct;
            case ImportConfigType.BambooHr:
                return ConnectionType.BambooHr;
            case ImportConfigType.SapErp:
                return ConnectionType.SapErp;
            case ImportConfigType.GoogleCloudPlatformCloudStorage:
                return ConnectionType.GoogleCloudPlatformCloudStorage;
            case ImportConfigType.Sas:
                return ConnectionType.Sas;
            case ImportConfigType.Dropbox:
                return ConnectionType.Dropbox;
            case ImportConfigType.GoogleDrive:
                return ConnectionType.GoogleDrive;
            case ImportConfigType.Jira:
                return ConnectionType.Jira;
            case ImportConfigType.Monday:
                return ConnectionType.Monday;
            case ImportConfigType.Zuora:
                return ConnectionType.Zuora;
            case ImportConfigType.AdobeAnalytics:
                return ConnectionType.AdobeAnalytics;
            case ImportConfigType.ZoomInfo:
                return ConnectionType.ZoomInfo;
            case ImportConfigType.Marketo:
                return ConnectionType.Marketo;
            case ImportConfigType.ActiveCampaign:
                return ConnectionType.ActiveCampaign;
            case ImportConfigType.Mailchimp:
                return ConnectionType.Mailchimp;
            case ImportConfigType.Infor:
                return ConnectionType.Infor;
            case ImportConfigType.CornerstoneOnDemand:
                return ConnectionType.CornerstoneOnDemand;
            case ImportConfigType.Gusto:
                return ConnectionType.Gusto;
            case ImportConfigType.PaychexFlex:
                return ConnectionType.PaychexFlex;
            case ImportConfigType.Zendesk:
                return ConnectionType.Zendesk;
            case ImportConfigType.ServiceNow:
                return ConnectionType.ServiceNow;
            case ImportConfigType.ZohoCrm:
                return ConnectionType.ZohoCrm;
            case ImportConfigType.Pipedrive:
                return ConnectionType.Pipedrive;
            case ImportConfigType.QuickBooks:
                return ConnectionType.QuickBooks;
            case ImportConfigType.Xero:
                return ConnectionType.Xero;
            case ImportConfigType.Freshbooks:
                return ConnectionType.Freshbooks;
            case ImportConfigType.ZohoBooks:
                return ConnectionType.ZohoBooks;
            case ImportConfigType.WaveFinancial:
                return ConnectionType.WaveFinancial;
            default:
                return undefined;
        }
    }
    static isExternal(importConfigType) {
        return ![
            ImportConfigType.S3Csv,
            ImportConfigType.Parquet,
            ImportConfigType.Excel,
            ImportConfigType.Global,
            ImportConfigType.Symon,
            ImportConfigType.Fwf
        ].includes(importConfigType);
    }
    static needsNoExtract(importConfigType) {
        if (!importConfigType)
            return false;
        return [ImportConfigType.S3Csv, ImportConfigType.Parquet, ImportConfigType.S3Parquet].includes(importConfigType);
    }
    static requiresAwsS3Creds(importConfigType) {
        return [ImportConfigType.Icm].includes(importConfigType);
    }
    static requiresTempFile(importConfigType) {
        return [ImportConfigType.Tqp].includes(importConfigType);
    }
    static isFlatFile(importConfigType, includeParquet = true) {
        if (includeParquet) {
            return [ImportConfigType.S3Csv, ImportConfigType.Parquet, ImportConfigType.Excel, ImportConfigType.Fwf].includes(importConfigType);
        }
        return [ImportConfigType.S3Csv, ImportConfigType.Excel, ImportConfigType.Fwf].includes(importConfigType);
    }
    static canUpdateSchema(importConfigType) {
        return [ImportConfigType.S3Csv, ImportConfigType.Excel, ImportConfigType.GSheets].includes(importConfigType);
    }
    static hasMalformed(importConfigType) {
        return [ImportConfigType.S3Csv, ImportConfigType.GSheets].includes(importConfigType);
    }
    // list of imports that support target parquet
    static supportTargetParquet(importConfigType, fileTypeSupportsTargetParquet) {
        if ([ImportConfigType.S3Csv, ImportConfigType.AmazonS3, ImportConfigType.Sftp, ImportConfigType.OneDrive].includes(importConfigType)) {
            return fileTypeSupportsTargetParquet;
        }
        return [
            ImportConfigType.Fwf,
            ImportConfigType.MySql,
            ImportConfigType.SalesForce,
            ImportConfigType.Workday,
            ImportConfigType.Snowflake,
            ImportConfigType.PostgreSql,
            ImportConfigType.MicrosoftSqlServer,
            ImportConfigType.AmazonAurora,
            ImportConfigType.AmazonRedshift,
            ImportConfigType.Oracle,
            ImportConfigType.Snowflake,
            ImportConfigType.MsSql,
            ImportConfigType.AgentSync,
            ImportConfigType.Tqp,
            ImportConfigType.NetSuite,
            ImportConfigType.Hubspot,
            ImportConfigType.Gong,
            ImportConfigType.WorkdayRaaS,
            ImportConfigType.Dynamics
        ].includes(importConfigType);
    }
    static escapeStringRegexp(str, dynamic = false) {
        // Escape characters with special meaning either inside or outside character sets.
        // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
        // (Taken from package escape-string-regexp, which Jest couldn't parse properly)
        if (dynamic) {
            return str
                .replace(/[|\\{}()[\]^$+?.]/g, '\\$&')
                .replace(/-/g, '\\x2d')
                .replace(/\*/g, '.*');
        }
        return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
    }
    hasModifiedColumn() {
        return this.checkColumnsType(ColumnUpdateType.MODIFY);
    }
    hasMaskedColumn() {
        return this.checkColumnsType(ColumnUpdateType.MASK);
    }
    hasDroppedColumn() {
        return this.checkColumnsType(ColumnUpdateType.DROP);
    }
    checkColumnsType(type) {
        if (this.columnsToUpdate?.values() === undefined) {
            return false;
        }
        const streamList = Array.from(this.columnsToUpdate.values());
        for (const streamValue of streamList) {
            for (const columnUpdate of streamValue) {
                if (columnUpdate.columnUpdateType === type) {
                    return true;
                }
            }
        }
        return false;
    }
    get isParquetImport() {
        return false;
    }
    get fileTypeSupportsTargetParquet() {
        return false;
    }
    get fileTypeSupportsDataPreprocess() {
        return false;
    }
    get isFileTypeCsv() {
        return false;
    }
    // if the target should do special cleaning of data or not
    get shouldTargetCleanData() {
        return false;
    }
    get supportTapFilter() {
        return false;
    }
};
__decorate([
    JsonConverter(new MapConverter(ColumnUpdate))
], ImportConfig.prototype, "columnsToUpdate", void 0);
__decorate([
    JsonConverter(new MapConverter())
], ImportConfig.prototype, "columnsToDrop", void 0);
__decorate([
    JsonConverter(new MapConverter())
], ImportConfig.prototype, "columnsToMask", void 0);
__decorate([
    JsonConverter(new MapConverter(ImportFilter))
], ImportConfig.prototype, "filters", void 0);
__decorate([
    OnDeserialized()
], ImportConfig.prototype, "ToColumnsUpdate", null);
ImportConfig = ImportConfig_1 = __decorate([
    JsonSchemaV2(importConfigSchema, importConfigSchemaValidation),
    JsonDiscriminatorProperty('importConfigType')
], ImportConfig);
export { ImportConfig };
//# sourceMappingURL=importConfig.js.map